import { apiRequest } from '@/core';
import { type SimpleEntity } from '@/types';

export const fetchRoleOptionsRequest = async () =>
  apiRequest<SimpleEntity[]>({
    endpoint: `api/members/roles`,
  });
